import Container from "../Container";
import {TableCellKey, TableCellValue} from "../../designSystem/Table";

export interface PaymentRecapProps {
    TRANSACTION_DATE: Date;
    TRANSACTION_ID: string;
    TRANSACTION_MONTANT: number;
}

const PaymentRecap = (props: PaymentRecapProps) => {
    return (
        <Container containerTitle={"Récapitulatif paiement"}>
            <table>
                <tbody>
                <tr>
                    <TableCellKey>Effectué le</TableCellKey>
                    <TableCellValue>{props.TRANSACTION_DATE.toLocaleDateString() + ' - ' + props.TRANSACTION_DATE.toLocaleTimeString()}</TableCellValue>
                </tr>
                <tr>
                    <TableCellKey>N° transaction</TableCellKey>
                    <TableCellValue>{props.TRANSACTION_ID}</TableCellValue>
                </tr>
                <tr>
                    <TableCellKey>Montant</TableCellKey>
                    <TableCellValue>{props.TRANSACTION_MONTANT} €</TableCellValue>
                </tr>
                </tbody>
            </table>
        </Container>
    );
}

export default PaymentRecap;